import { rolesThatCanCreateTripsInThePast } from './rolesThatCanCreateTripsInThePast';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export function useCanCreateTripInThePast() {
  const { role } = useUserRoles();
  return role && rolesThatCanCreateTripsInThePast.includes(role);
}
